// Angular imports
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Import config
import { ConfigService } from '../config/config.service';
import { DataService } from './data.service';
import { VersionHistory } from '../types/version-history';
import { LoaderService } from '../loader/loader.service';

@Injectable({
    providedIn: 'root'
})
export class ChangesService {
    constructor(private config: ConfigService, private http: HttpClient, private dataService: DataService, private loaderService: LoaderService) { }

    public async getChanges(): Promise<VersionHistory[]> {

        // Get the change log for the latest version
        return this.loaderService.performAsyncTask(async ()=> {
            return await this.dataService.getVersionHistory();
        }) 
    }
}
